import Link from 'next/link'
import { CourseLocation } from '../../@types/admin'
import CustomLink from './CustomLink'
import { formatGerman } from '@/src/components/core/lib/date'

export default function UpcomingCourses({
  locations,
}: {
  locations: CourseLocation[]
}) {
  return (
    <ul className="mt-8 grid gap-4 md:mt-10 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 xl:grid-cols-4">
      {locations.map((location) => (
        <li
          key={location.name}
          className="flex flex-col justify-between rounded-lg bg-gray-50 p-5 md:p-6"
        >
          <div>
            <h3 className="text-3xl font-extrabold md:text-4xl">
              {location.name}
            </h3>
            <ul className="mt-2 space-y-2 md:mt-0 lg:mt-3">
              {location.courses.map((course) => (
                <li key={course.slug}>
                  <CustomLink href={location.link + '?course=' + course.slug}>
                    <a className="hover:underline">
                      {formatTimeslots(course.timeslots)}
                    </a>
                  </CustomLink>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-4">
            <Link href={location.link} className="font-bold text-purple-600">
              Alle anzeigen
            </Link>
          </div>
        </li>
      ))}
    </ul>
  )
}

const formatTimeslots = (
  timeslots: {
    day: string
    isoDay: string
    slots: {
      start: string
      end: string
    }[]
  }[]
) => {
  if (timeslots.length === 1) {
    return formatGerman(timeslots[0].isoDay, 'EEEE, d. MMM yyyy')
  }
  const allSameMonth = timeslots.every((timeslot) => {
    const month = new Date(timeslot.isoDay).getMonth()
    return month === new Date(timeslots[0].isoDay).getMonth()
  })

  const formattedSlots = timeslots.map((timeslot) =>
    formatGerman(timeslot.isoDay, allSameMonth ? 'EEEE, d.' : 'EEEE, d. MMM')
  )
  let formattedString = formattedSlots.join(' & ')
  if (allSameMonth) {
    formattedString += ' ' + formatGerman(timeslots[0].isoDay, 'MMM')
  }
  formattedString += ' ' + formatGerman(timeslots[0].isoDay, 'yyyy')
  return formattedString
}
